export default {
  title: 'Créer une clé API',
  reveal_warning: 'Enregistrez cette clé maintenant — elle ne sera plus affichée.',
  form: {
    name: 'Nom',
    name_placeholder: 'ex. Clé de production',
  },
  buttons: {
    cancel: 'Annuler',
    create: 'Créer',
    done: 'Terminé',
  },
  toasts: {
    error: 'Impossible de créer la clé. Veuillez réessayer.',
  },
};
